export default "__VITE_ASSET__CM7$HfgO__"